import { FileEntryFM } from '@bm-js/atlascloud-shared'
import { Button } from '@bm-js/atlascloud-ui'
import InfoBox from './InfoBox'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  file: FileEntryFM
  deleteFile: (file: FileEntryFM) => void
}

const MediaItemDeleteButton = ({ file, deleteFile }: Props) => {
  const { tr } = useTr()
  if (file.usedIn)
    return (
      <div className='flex gap-2 items-center'>
        <p className='m0 xxs inter'>{tr(TrKey.mediaUsed)}</p>
        <InfoBox
          w={400}
          text={tr(TrKey.mediaUsedIn, { usedIn: file.usedIn })} // TODO: translate usedIn
        />
      </div>
    )
  return (
    <Button danger onClick={() => deleteFile(file)}>
      {tr(TrKey.delete)}
    </Button>
  )
}

export default MediaItemDeleteButton
